<template>
<el-dialog
  :visible.sync="dialogVisible"
  title="修改法院信息"
  @closed="onClose"
  append-to-body
  width="500px">
  <el-descriptions column="1" border>
    <el-descriptions-item label="法院名称">
      <el-input v-model="form.name" placeholder="请输入法院名称" size="mini"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="法院地址">
      <el-input v-model="form.address" placeholder="请输入法院地址" size="mini"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="年限限制">
      <el-input-number v-model="form.year_restrictions" placeholder="请输入年限限制" size="mini"></el-input-number>
    </el-descriptions-item>
    <el-descriptions-item label="月份限制">
      <el-input-number v-model="form.month_restrictions" placeholder="请输入月份限制" size="mini"></el-input-number>
    </el-descriptions-item>
    <el-descriptions-item label="备注">
      <el-input v-model="form.remark" placeholder="请输入备注" size="mini"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="状态">
      <el-switch v-model="form.status" size="mini" :active-value="1" :inactive-value="0"></el-switch>
    </el-descriptions-item>
  </el-descriptions>
  <template #footer>
    <el-button @click="dialogVisible = false" size="mini">取消</el-button>
    <el-button type="primary" @click="submit" size="mini">确定</el-button>
  </template>
</el-dialog>
</template>

<script>
// `id` int(11) NOT NULL AUTO_INCREMENT COMMENT 'ID',
// `name` varchar(100) NOT NULL DEFAULT '' COMMENT '法院名称',
// `address` varchar(255) NOT NULL DEFAULT '' COMMENT '法院地址',
// `year_restrictions` int(11) NOT NULL DEFAULT '0' COMMENT '年限限制',
// `month_restrictions` int(11) NOT NULL DEFAULT '0' COMMENT '月份限制',
// `remark` varchar(255) DEFAULT NULL COMMENT '备注',
// `status` int(11) NOT NULL DEFAULT '1' COMMENT '状态：0-禁用，1-启用',
// `create_time` datetime NOT NULL DEFAULT CURRENT_TIMESTAMP COMMENT '创建时间',
// `update_time` datetime NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP COMMENT '更新时间',
import ButlerHttp from "../../../common/ButlerHttp";

export default {
  name: "CourtEditor",
  data() {
    return {
      dialogVisible: false,
      form: {
        id: 0,
        name: "",
        address: "",
        year_restrictions: 0,
        month_restrictions: 0,
        remark: "",
        status: 1,
      },
      callback:null
    }
  },
  mounted() {},
  methods: {
    show(row, callback){
      this.dialogVisible = true;
      this.form = this.fromData(row);
      this.callback = callback;
    },
    submit(){
      let that = this;
      ButlerHttp.post("CourtInfo/save",{
        ...this.form
      },ret=>{
        if(ret.code){
          that.dialogVisible = false;
          that.callback();
        }
      });
    },
    onClose(){
      this.callback = null;
      this.dialogVisible = false;
    },
    fromData(data){
      return Object.assign({
        id:0,
        name:"",
        address:"",
        year_restrictions:0,
        month_restrictions:0,
        remark:"",
        status:1,
      },data);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/court/CourtEditor.vue